import * as React from "react";
import { useMediaQuery, useTheme } from "@mui/material";

import Form from "../../../../attachments/Form";
import { useResponsive } from "../../../../../../../hooks/useResponsive";
import './AttachFile.scss';
import FormDialog from "../../../../../../../components/Dialog/FormDialog";

export default function AttachFileDialog({
  open,
  close,
  canSubmit,
  file,
  handleFileChange,
  handleNameChange,
  handleSubmit,
  loading,
  name,
}) {
  const isMobile = useResponsive("down", "md");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <React.Fragment>
      <FormDialog
        open={open}
        handleClose={() => close(false)}
        loading={loading}
        fullScreen={fullScreen}
        handleSubmit={handleSubmit}
        buttonTxt="Save"
        title="AttachFile"
        // width="400px"
        fullWidth={true}
        disabled={!canSubmit || loading}
      >
        <Form
          file={file}
          name={name}
          handleNameChange={handleNameChange}
          handleFileChange={handleFileChange}
          isMobile={isMobile}
          className={isMobile ? "mobile-attach-file-dialog-form" : ""}
        />
      </FormDialog>
    </React.Fragment>
  );
}
